<template>
  <div v-if="loading" :class="loadingType==='fixed'?'fixed':'absolute'" @mousewheel.prevent>
    <div class="loading">
      <a-icon type="sync" spin />
    </div>
  </div>
</template>

<script>
// 遮罩组建
// 参数: 遮罩开关: loading(必填),遮罩类型: loadingType(选填)
// loading 传 Boolean 值，为真时出现，为假时关闭。
// loadingType 传 'fixed' 或者 'absolute' 默认 fixed 。全浏览器遮罩, absolute 局部遮罩 。注意使用 absolute 类型时, 父节点的position 值不为默认 （推荐设为 relative )
export default {
  name: 'Name',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    loadingType: {
      type: String,
      default: 'fixed'
    }
  },
  data: function() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  color:white;
  font-size:36px
}
.fixed {
  background: rgba(0,0,0,0.3);
    z-index: 9999;
  position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.absolute {
  background: rgba(0,0,0,0.3);
    z-index: 9999;
  position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/component/LoadingMask.vue